<template>
  <div class="followlist">
    <div class="followlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom:0px;"
        @submit.native.prevent
      >
      <el-button
        type="warning"
        icon="el-icon-arrow-left"
        style="margin-right: 10px;"
        plain
        @click="toPatrollingRod"
        >返回</el-button
      >
        <!--
          <el-form-item label="设备编号">
            <el-input
              v-model.trim="formInline.inputdeviceno"
              placeholder="请输入设备编号"
              @keyup.enter.native.prevent="enterSearchMember"
            ></el-input>
          </el-form-item>
        -->
        <!-- <el-form-item>
          <el-button type="primary"
            icon="el-icon-search"
            plain @click="onSubmit"
            >查询</el-button
          >
        </el-form-item> -->
        <el-form-item>
          <el-button
            type="primary"
            plain
            class="el-icon-plus"
            @click="dialogFormVisible = true;"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <!-- 封装的 i-table组件 -->
        <div class="table-page">
          <i-table
            :list="list"
            @handleSelectionChange="handleSelectionChange"
            :options="options"
            :columns="columns"
            :operates="operates"
          ></i-table>
        </div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog
        title="新增设备信息"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="followxz"
        @close="closexz"
      >
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item
            label="巡更时间"
            :label-width="formLabelWidth"
            prop="time"
          >
            <el-time-picker
              v-model="form.time"
              :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
              }"
              placeholder="任意时间点"
              @change="timeChange"
              value-format="HH:mm"
              format="HH:mm"
              style="width:100%"
              key="patrolStart"
              id="patrolStart"
            >
            </el-time-picker>
          </el-form-item>
          <el-form-item
            label="巡更时间范围(分钟)"
            :label-width="formLabelWidth"
            prop="interval"
          >
            <el-input-number
              v-model="form.interval"
              :precision="0"
              :min="30"
              :max="120"
              placeholder="请输入巡更范围"
              @change="timeChange"
              style="width:100%"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="巡更开始时间" :label-width="formLabelWidth">
            {{ form.startTime }}
          </el-form-item>
          <el-form-item label="巡更结束时间" :label-width="formLabelWidth">
            {{ form.finishTime }}
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button
            type="primary"
            @click="submitForm('form');"
            :loading="addLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 弹出修改 -->
      <el-dialog
        title="修改设备信息"
        :visible.sync="dialogFormEdit"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="followedit"
        @close="closexg"
      >
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item
            label="巡更时间"
            :label-width="formLabelWidth"
            prop="time"
          >
            <el-time-picker
              v-model="formedit.time"
              :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
              }"
              placeholder="任意时间点"
              @change="editTimeChange"
              value-format="HH:mm"
              format="HH:mm"
              style="width:100%"
            >
            </el-time-picker>
          </el-form-item>
          <el-form-item
            label="巡更时间范围(分钟)"
            :label-width="formLabelWidth"
            prop="interval"
          >
            <el-input-number
              v-model="formedit.interval"
              :precision="0"
              :min="30"
              :max="120"
              placeholder="请输入巡更范围"
              @change="editTimeChange"
              style="width:100%"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="巡更开始时间" :label-width="formLabelWidth">
            <span style="display:block;height:40px;line-height:40px;">
              {{ formedit.patrolStart }}</span
            >
          </el-form-item>
          <el-form-item label="巡更结束时间" :label-width="formLabelWidth">
            <span style="display:block;height:40px;line-height:40px;">
              {{ formedit.patrolEnd }}
            </span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxg">取 消</el-button>
          <el-button
            type="primary"
            @click="submitFormEdit('formedit');"
            :loading="editLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import iTable from "@/components/iTable.vue";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      deviceId: this.$route.query.id, //设备id
      addLoading: false,
      editLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 8, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      formInline: {
        inputdeviceno: ""
      },
      options: {
        stripe: true, // 是否为斑马纹 table
        //loading: true, // 是否添加表格loading加载动画
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        mutiSelect: false // 是否支持列表项选中功能
      }, // table 的参数
      columns: [
        {
          prop: "patrolStart",
          label: "开始时间",
          align: "center"
        },
        {
          prop: "patrolEnd",
          label: "结束时间",
          align: "center"
        },
        {
          prop: "patrolTime",
          label: "巡更时间",
          align: "center"
        },
        {
          prop: "patrolDuration",
          label: "时间范围 ",
          align: "center"
        }
      ], // 需要展示的列
      operates: {
        width: 200,
        fixed: "right",
        offset: 20,
        list: [
          {
            id: "1",
            label: "编辑",
            type: "primary",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.handleEdit(index, row);
            }
          },
          {
            id: "2",
            label: "删除",
            type: "danger",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.handleDelete(index, row); 
            }
          }
        ]
      }, // 列操作按钮
      // 新增表单dialog
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        time: null,
        interval: null,
        startTime: null,
        finishTime: null
      },
      formLabelWidth: "150px",
      //修改表单dialog
      dialogFormEdit: false,
      formedit: {
        time: null,
        interval: null,
        patrolStart: null,
        patrolEnd: null
      },
      rules: {
        // 新增正则验证匹配规则
        time: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          }
          //可以设置双重验证标准
          //{min: 5, max:15, message: '长度在 5到 15 个字符'},
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' },
          //{ pattern: /^HC/, message: '请输入由HC开头的字符' }
          // { min: 1, max: 30, message: "长度在 1到 30 个字符" } //by  guo 2020-4-26-18:12修改
        ],
        interval: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          {
            pattern: /^[+]{0,1}(\d+)$/,
            message: "请输入正整数!",
            trigger: "blur"
          }
          //可以设置双重验证标准
          // { min: 1, max: 50, message: "长度在 1到 50 个字符" }
        ],
        xzname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 20, message: "长度在 1到 20 个字符" }
        ],

        // 修改正则验证匹配规则
        time: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          //可以设置双重验证标准
          //{ min: 5, max:15,  message: '长度在 5到 15 个字符', },
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          // { pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_-])[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" } //by  guo 2020-4-26-18:12修改
        ],
        editsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 50, message: "长度在 1到 50 个字符" }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        editname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 20, message: "长度在 1到 20 个字符" }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ]
      },
      fileFlag: false
    };
  },
  methods: {
    // 选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },

    //点击查询
    onSubmit(newVal, oldVal) {
      console.log(this.deviceId, "ididioidd");
      console.log(newVal, oldVal);
      this.getTableData(this.deviceId, (this.pageNum = 1), (this.pageSize = 8));
    },

    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.deviceId != null) {
        this.getTableData(deviceId, (this.pageNum = 1), (this.pageSize = 8));
      }
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
      }
    },

    // 返回
    toPatrollingRod() {
      bus.$emit("close_current_tags");
    },

    // 点击弹出修改信息的弹窗
    handleEdit(index, row) {
      (this.dialogFormEdit = true), //打开修改弹窗
        console.log(index, row);
      this.listIndex = index; //记录索引
      console.log(this.listIndex);
      // this.formedit=row;//记录数据
      row.interval = row.patrolDuration.split("分钟")[0];
      row.time = row.patrolTime;
      this.formedit = Object.assign({}, row); //深拷贝记录
      this.dialogFormEdit = true; //打开修改弹窗
    },

    //点击修改弹窗的 确定按钮提交修改的数据
    submitFormEdit(datainfo) {
      ///正则匹配规则rules
      this.$refs[datainfo].validate(valid => {
        //判断数据是否存在
        console.log(this.formedit);
        if (valid) {
          let param = {
            id: this.formedit.id,
            patrolTime: this.formedit.time,
            patrolDuration: this.formedit.interval,
            patrolStart: this.formedit.patrolStart,
            patrolEnd: this.formedit.patrolEnd
          };
          console.log(param);
          this.editLoading = true;
          this.$postJson("dmc/patrol/patrolUpdateTask", param).then(res => {
            console.log(res);
            this.editLoading = false;
            this.dialogFormEdit = false; //关闭修改弹窗
            this.getTableData();
            if (res.code == "200") {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success"
                });
              }, 300);
              console.log("修改成功!");
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error"
                });
              }, 300);
            }
            //console.log(this.$store.state.count)
          });
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },

    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false
      })
        .then(() => {
          console.log(index, row);
          let id = Number(row.id);
          console.log(id);
          this.$postJson(`dmc/patrol/patrolDeleteTask`, {
            id: id
          }).then(res => {
            //旧 dmc/follow/deleteById/
            if (res.code == 200) {
              // this.$bus.$emit("handleDeletechange_follow"); //发送一个change事件
              this.getTableData();
              console.log(res);
              this.$message({
                type: "success",
                message: res.message
              });
            } else {
              this.$message({
                type: "error",
                message: res.message
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
      this.form.time = "";
      this.form.interval = "";
      this.form.startTime = "";
      this.form.finishTime = "";
    },

    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    //关闭修改的dialog
    closexg() {
      this.$refs.formedit.resetFields(); //移除校验结果并重置字段值
      this.formedit.time = "";
      this.formedit.interval = "";
      this.formedit.patrolStart = "";
      this.formedit.patrolEnd = "";
    },

    //点击修改取消  重置表单以及验证
    cancelxg() {
      this.dialogFormEdit = false;
      this.$refs.formedit.resetFields(); //移除校验结果并重置字段值
    },
    // 新增时间处理
    timeChange() {
      // 间隔时间最小值
      if (this.form.interval < 30) {
        this.form.interval = 30;
      }
      // 间隔时间最大值
      if (this.form.interval > 120) {
        this.form.interval = 120;
      }
      console.log(this.form.time, "this.form.timethis.form.time");
      if (!this.form.time) {
        this.form.startTime = "";
        this.form.finishTime = "";
        return console.log("时间为空!!");
      }
      if (!this.form.interval) {
        this.form.startTime = "";
        this.form.finishTime = "";
        return console.log("间隔时间为空");
      }
      // 输入的小时
      let timeH = this.form.time.split(":")[0] * 1;
      // 输入的分钟
      let timeM = this.form.time.split(":")[1] * 1;
      console.log("时:" + timeH, "分:" + timeM);
      // 输入的间隔时间
      let interval = this.form.interval * 1;
      console.log("间隔时间:" + interval);
      console.log(parseInt(interval / 60), "interval", interval % 60);
      /* 开始时间 */
      // 计算分钟
      // 如果分钟大于 1 个小时
      if (parseInt(interval / 60)) {
        // 减去整小时的
        timeH = timeH - parseInt(interval / 60);
        timeM = timeM - Number(interval % 60);
        console.log(timeM, "timeMtimeMtimeM");
        if (timeM < 0) {
          console.log("进来了");

          timeH = timeH - 1;
          timeM = 60 + timeM;
        }
      } else {
        // 间隔分钟大于输入的分钟,不够减
        if (Number(timeM) < Number(interval)) {
          timeH = timeH - 1;
          timeM = 60 - Number(interval % 60) + Number(timeM);
          // 间隔时间小于输入的分钟,够减
        } else if (Number(timeM) >= Number(interval)) {
          // 不满一小时
          timeM = timeM - Number(interval % 60);
        }
      }
      // 小时为负数,置为24
      if (timeH < 0) {
        timeH = 24 + timeH;
      }

      timeH = timeH < 10 ? "0" + timeH : timeH;
      timeM = timeM < 10 ? "0" + timeM : timeM;
      console.log(timeH + ":" + timeM);
      this.form.startTime = timeH + ":" + timeM;
      /* 结束时间 */
      // 输入的小时
      let lastTimeH = this.form.time.split(":")[0] * 1;
      // 输入的分钟
      let lastTimeM = this.form.time.split(":")[1] * 1;
      console.log("时:" + timeH, "分:" + timeM);
      // 输入的间隔时间
      let lastTnterval = this.form.interval * 1;
      // 计算分钟
      // 如果分钟大于 1 个小时
      if (parseInt(lastTnterval / 60)) {
        // 先加整小时的
        lastTimeH = lastTimeH + parseInt(lastTnterval / 60);
        lastTimeM = lastTimeM + Number(lastTnterval % 60);
        console.log(lastTimeM, "lastTimeMlastTimeMlastTimeM");
        if (lastTimeM > 60) {
          console.log("进来了");
          lastTimeH = lastTimeH + 1;
          lastTimeM = lastTimeM - 60;
        } else if (lastTimeM == 60) {
          // 满一小时
          lastTimeH = lastTimeH + 1;
          lastTimeM = 0;
        }
      } else {
        // 分钟再加
        lastTimeM = lastTimeM + Number(lastTnterval % 60);
        // 间隔分钟大于输入的分钟,不够减
        if (lastTimeM > 60) {
          lastTimeH = lastTimeH + 1;
          lastTimeM = lastTimeM - 60;
        } else if (lastTimeM == 60) {
          // 满一小时
          lastTimeH = lastTimeH + 1;
          lastTimeM = 0;
        }
      }
      if (lastTimeH >= 24) {
        lastTimeH = lastTimeH - 24;
      }
      lastTimeH = lastTimeH < 10 ? "0" + lastTimeH : lastTimeH;
      lastTimeM = lastTimeM < 10 ? "0" + lastTimeM : lastTimeM;
      console.log(lastTimeH + ":" + lastTimeM);
      this.form.finishTime = lastTimeH + ":" + lastTimeM;
    },
    // 修改时间处理
    editTimeChange() {
      // 间隔时间最小值
      if (this.formedit.interval < 30) {
        this.formedit.interval = 30;
      }
      // 间隔时间最大值
      if (this.formedit.interval > 120) {
        this.formedit.interval = 120;
      }
      console.log(this.formedit.time, "this.form.timethis.form.time");
      if (!this.formedit.time) {
        this.formedit.patrolStart = "";
        this.formedit.patrolEnd = "";
        return console.log("时间为空!!");
      }
      if (!this.formedit.interval) {
        this.formedit.patrolStart = "";
        this.formedit.patrolEnd = "";
        return console.log("间隔时间为空");
      }
      // 输入的小时
      let timeH = this.formedit.time.split(":")[0] * 1;
      // 输入的分钟
      let timeM = this.formedit.time.split(":")[1] * 1;
      console.log("时:" + timeH, "分:" + timeM);
      // 输入的间隔时间
      let interval = this.formedit.interval * 1;
      console.log("间隔时间:" + interval);
      console.log(parseInt(interval / 60), "interval", interval % 60);
      /* 开始时间 */
      // 计算分钟
      // 如果分钟大于 1 个小时
      if (parseInt(interval / 60)) {
        // 减去整小时的
        timeH = timeH - parseInt(interval / 60);
        timeM = timeM - Number(interval % 60);
        console.log(timeM, "timeMtimeMtimeM");
        if (timeM < 0) {
          console.log("进来了");
          timeH = timeH - 1;
          timeM = 60 + timeM;
        }
      } else {
        // 间隔分钟大于输入的分钟,不够减
        if (Number(timeM) < Number(interval)) {
          timeH = timeH - 1;
          timeM = 60 - Number(interval % 60) + Number(timeM);
          // 间隔时间小于输入的分钟,够减
        } else if (Number(timeM) >= Number(interval)) {
          // 不满一小时
          timeM = timeM - Number(interval % 60);
        }
      }
      // 小时为负数,置为24
      if (timeH < 0) {
        timeH = 24 + timeH;
      }

      timeH = timeH < 10 ? "0" + timeH : timeH;
      timeM = timeM < 10 ? "0" + timeM : timeM;
      console.log(timeH + ":" + timeM);
      this.formedit.patrolStart = timeH + ":" + timeM;
      /* 结束时间 */
      // 输入的小时
      let lastTimeH = this.formedit.time.split(":")[0] * 1;
      // 输入的分钟
      let lastTimeM = this.formedit.time.split(":")[1] * 1;
      console.log("时:" + timeH, "分:" + timeM);
      // 输入的间隔时间
      let lastTnterval = this.formedit.interval * 1;
      // 计算分钟
      // 如果分钟大于 1 个小时
      if (parseInt(lastTnterval / 60)) {
        // 先加整小时的
        lastTimeH = lastTimeH + parseInt(lastTnterval / 60);
        lastTimeM = lastTimeM + Number(lastTnterval % 60);
        console.log(lastTimeM, "lastTimeMlastTimeMlastTimeM");
        if (lastTimeM > 60) {
          console.log("进来了");
          lastTimeH = lastTimeH + 1;
          lastTimeM = lastTimeM - 60;
        } else if (lastTimeM == 60) {
          // 满一小时
          lastTimeH = lastTimeH + 1;
          lastTimeM = 0;
        }
      } else {
        // 分钟再加
        lastTimeM = lastTimeM + Number(lastTnterval % 60);
        // 间隔分钟大于输入的分钟,不够减
        if (lastTimeM > 60) {
          lastTimeH = lastTimeH + 1;
          lastTimeM = lastTimeM - 60;
        } else if (lastTimeM == 60) {
          // 满一小时
          lastTimeH = lastTimeH + 1;
          lastTimeM = 0;
        }
      }
      if (lastTimeH >= 24) {
        lastTimeH = lastTimeH - 24;
      }
      lastTimeH = lastTimeH < 10 ? "0" + lastTimeH : lastTimeH;
      lastTimeM = lastTimeM < 10 ? "0" + lastTimeM : lastTimeM;
      console.log(lastTimeH + ":" + lastTimeM);
      this.formedit.patrolEnd = lastTimeH + ":" + lastTimeM;
    },
    //新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate(valid => {
        if (valid) {
          console.log(this.form, "this.formthis.formthis.form");
          // return;
          let param = {
            deviceId: this.deviceId,
            patrolTime: this.form.time,
            patrolDuration: this.form.interval,
            patrolStart: this.form.startTime,
            patrolEnd: this.form.finishTime
          };
          console.log(param);
          //this.loading = true
          this.addLoading = true;
          this.$postJson("dmc/patrol/patrolAddTask", param)
            .then(res => {
              console.log(res);
              this.addLoading = false;
              this.dialogFormVisible = false;
              this.$refs.form.resetFields(); //移除校验结果并重置字段值
              // this.$bus.$emit("submitFormchange_follow"); //发送一个change事件
               this.getTableData();
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
                console.log("提交成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error"
                  });
                }, 300);
              }
              //console.log(this.$store.state.count)
              //this.loading = false
            })
            .catch(res => {
              this.$message({
                type: "error",
                message: res.message
              });
            });
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },

    //获取表格数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceId: this.deviceId
      };
      console.log(param);
      this.loading = true;
      this.$postJson("dmc/patrol/patrolSelectTask", param)
        .then(res => {
          console.log(res);
          //判断是否有数据
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            res.result.list.forEach(item => {
              item.patrolDuration = item.patrolDuration + "分钟";
            });
            this.list = res.result.list;
            //this.$set(this.tableData,res.result.list)
            console.log(this.list);
            setTimeout(() => {
              this.loading = false;
            }, 500);
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 500);
          }
        })
        .catch(error => {
          console.log(error, "errorerror");
          this.list = [];
          this.totalDataNumber = 0;
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },

    //导入
    intoList() {
      this.dialogVisible = true;
    },

    //确认导入
    getUrl(event) {
      let file = event.target.files;
      console.log(file);
      this.fileFlag = true; //by guo 2020-8-4-15:18添加
      this.formData = new FormData();
      this.formData.append("file", file[0]);
    },

    //确认导入
    intoForm() {
      if (this.fileFlag) {
        this.$postFormData(
          "dmc/propertyManagement/merchantToLead",
          this.formData
        ).then(res => {
          this.dialogVisible = false;
          this.formData = {};
          this.fileFlag = false;
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.getTableData();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      } else {
        this.$message({ message: "请选择文件", type: "error" });
      }
    },

    closeDialogReset() {
      this.$refs.file.value = ""; // 清空file文件
    },

    //模板下载
    downLoad() {
      window.location.href = baseURL + "dmc/api/downTemplate";
    },

    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    }
  },

  watch: {
    currentPage(newV, oldV) {
      console.log(newV, oldV);
      deep: true; //深度监听
    },
    //  tableData(newV,oldV) {
    //      console.log(newV,oldV);
    //      deep: true  //深度监听
    // },
    data: "onSubmit" //值可以为methods的方法
  },

  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.getTableData();
  },

  mounted() {
    //监听submitFormchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("submitFormchange_follow", () => {
      this.getTableData();
    }),
      //监听handleDeletechange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("handleDeletechange_follow", () => {
        this.getTableData();
      }),
      //监听submitFormEditchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("submitFormEditchange_follow", () => {
        this.getTableData();
      }),
      this.getTableData();
  },
  components: { iTable }
};
</script>
<style lang="scss" scoped>
.followlist {
  background: #fff;
  .followlist-m {
    padding: 10px 0 0 5px;
  }
}

// 修改element-ui默认的样式
.del {
  color: red !important;
}
.fangqu {
  color: green !important;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

//新增的dialog
@media screen and (min-width: 1200px) {
  ::deep .followxz .el-dialog {
    width: 30% !important;
    .el-dialog__body {
      .el-form {
        .el-form-item__content {
          line-height: 40px;
        }
      }
    }
  }
}

//修改的dialog
@media screen and (min-width: 1200px) {
  ::deep .followedit .el-dialog {
    width: 30% !important;
  }
}
</style>
